"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var button_1 = require("../../components/button/button");
var helpButton_1 = require("../../components/button/helpButton");
var helpUrls_1 = require("../helpUrls");
var VendorUserDetailPage = /** @class */ (function (_super) {
    __extends(VendorUserDetailPage, _super);
    function VendorUserDetailPage(api, navigator, currentUserManager, recordId) {
        var _this = _super.call(this, __1.PageTypes.VendorUserDetail, 'New Vendor User') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.recordId = recordId;
        _this.goToHistoryPage = function () {
            _this.navigator.goToHistoryPage({ historyType: __1.HistoryTypes.VendorUserHistory, recordId: _this.recordId });
        };
        _this.deactivate = function () {
            _this._form.model.isActive = false;
            _this.api.put(__1.EndpointUrls.Vendors + '/deactivate', _this.recordId, null);
            _this.deactivateButton.setVisibility(false);
            _this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.RecordDeactivated, _this._form.model);
            _this.navigator.goToVendorUserList();
        };
        _this.activate = function () {
            _this._form.model.isActive = true;
            _this.api.put(__1.EndpointUrls.Vendors + '/activate', _this.recordId, null);
            _this.deactivateButton.setVisibility(true);
            _this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.RecordActivated, _this._form.model);
            _this.navigator.goToVendorUserList();
        };
        _this.showDeactivatedAlert = function () {
            _this.alert.show({
                alertType: __1.AlertType.Error,
                heading: 'Vendor User Inactive',
                message: 'This account is not active and currently cannot login.',
                button: new button_1.default({
                    onClick: _this.activate,
                    processingText: 'Activating...',
                    text: 'Activate'
                })
            });
        };
        _this.loadRecord = function () { return __awaiter(_this, void 0, void 0, function () {
            var vendorUser, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._isLoading = true;
                        this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.RecordLoading);
                        this.title = 'Edit Vendor User';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getById(__1.EndpointUrls.Vendors, this.recordId)];
                    case 2:
                        vendorUser = _b.sent();
                        if (!vendorUser.isActive) {
                            this.showDeactivatedAlert();
                        }
                        else if (vendorUser.lockedOut) {
                            this.showLockedOutAlert();
                        }
                        else {
                            this.deactivateButton.setVisibility(true);
                        }
                        this._form.setModel(vendorUser);
                        this.historyButton.setVisibility(true);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.RecordLoadFailure, 'Unable to load record for edit');
                        return [3 /*break*/, 4];
                    case 4:
                        this._isLoading = false;
                        this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.RecordLoaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.showLockedOutAlert = function () {
            _this.alert.show({
                alertType: __1.AlertType.Success,
                heading: 'User locked out',
                message: 'This account is locked due to the number of failed login attempts',
                button: new button_1.default({
                    text: 'Unlock Account',
                    processingText: 'Unlocking...',
                    onClick: _this.unlockAccount
                })
            });
        };
        _this.cancel = function () {
            _this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.Cancel);
            _this.navigator.goToVendorUserList();
        };
        _this.unlockAccount = function (button) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.Unlocking);
                        return [4 /*yield*/, this.api.post(__1.EndpointUrls.Vendors + '/Unlock/' + this.recordId, {})];
                    case 1:
                        _a.sent();
                        button.setProcessing(false);
                        this._form.model.lockedOut = false;
                        this.alert.show({
                            alertType: __1.AlertType.Success,
                            heading: 'Account unlocked',
                            message: 'This account has been unlocked.'
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.promptToConfirmPasswordReset = function () {
            _this.alert.show({
                alertType: __1.AlertType.Error,
                heading: 'Reset vendor password',
                message: 'This will reset the users password to the system default password for vendor users.',
                button: new button_1.default({
                    text: 'Confirm Reset',
                    processingText: 'Resetting...',
                    onClick: _this.resetToDefaultPassword
                })
            });
        };
        _this.resetToDefaultPassword = function (button) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post(__1.EndpointUrls.Vendors + '/ResetToDefaultPassword/' + this.recordId, {})];
                    case 1:
                        _a.sent();
                        this.alert.show({
                            alertType: __1.AlertType.Success,
                            heading: 'Password reset',
                            message: 'The password has been reset to the default password for vendor users.'
                        });
                        button.setProcessing(false);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.helpButton = new helpButton_1.default(helpUrls_1.HelpUrlType.VendorDetailPage, null, navigator, api);
        _this.observationProvider = new __1.ObservationProvider();
        _this.buildForm();
        _this.confirmationPrompt = new __1.ConfirmationPrompt(!!recordId, 'Deactivate Vendor User', 'Deactivating this account will restrict access to the system for the user. Are you sure you want to deactive this account?', 'Deactivate', 'Cancel');
        _this.confirmationPrompt.observationProvider.observe(_this.deactivate, __1.ConfirmationPromptActions.Confirmed);
        _this.resetPasswordButton = new button_1.default({
            leftIcon: __1.Icons.Key,
            onClick: _this.promptToConfirmPasswordReset,
            isVisible: !!recordId
        });
        _this.historyButton = new button_1.default({
            isVisible: false,
            onClick: _this.goToHistoryPage,
            leftIcon: __1.Icons.Clock
        });
        _this.cancelButton = new button_1.default({
            text: 'Cancel',
            onClick: _this.cancel
        });
        _this.saveButton = new button_1.default({
            buttonType: __1.ButtonTypes.Submit,
            text: 'Save',
            onClick: _this.form.submit,
            processingText: 'Saving...'
        });
        _this.deactivateButton = new button_1.default({
            leftIcon: __1.Icons.Trash,
            onClick: _this.confirmationPrompt.show,
            isVisible: false
        });
        if (recordId) {
            _this.loadRecord();
        }
        return _this;
    }
    Object.defineProperty(VendorUserDetailPage.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorUserDetailPage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorUserDetailPage.prototype, "isApp", {
        get: function () {
            return this.currentUserManager.clientChecker.isMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    VendorUserDetailPage.prototype.buildForm = function () {
        var _this = this;
        var fields = [
            new __1.VendorCompanyDropdown(this.api, 'vendorCompanyId', true),
            new __1.TextField('title', 'Title', false, 250),
            new __1.TextField('firstName', 'First Name', true, 100, 'First name is required'),
            new __1.TextField('lastName', 'Last Name', true, 100, 'Last name is required'),
            new __1.TextField('phone', 'Phone', true, 50, 'Required'),
            new __1.EmailField('email', true, 'Login Email'),
        ];
        this._form = new __1.SubmittableForm(__1.EndpointUrls.Vendors, this.api, fields);
        this._form.observationProvider.observe(function () { _this.saveButton.setProcessing(false); }, __1.SubmittableFormActions.SubmissionFailure);
        this.observationProvider.notifyObservers(__1.VendorUserDetailPageActions.FormLoaded);
    };
    return VendorUserDetailPage;
}(__1.BasePage));
exports.default = VendorUserDetailPage;
